import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import {FreeToPlayAnimatedIconDefaultBox} from "./free-to-play-animated-icon.default.box";

const PCBox = styled(FreeToPlayAnimatedIconDefaultBox)`
    width: 190px;
`;

const MobileBox = styled(FreeToPlayAnimatedIconDefaultBox)`
    width: 130px;
`;


export const FreeToPlayAnimatedIconBox = styledByDevice(PCBox,MobileBox);